import axiosInstance from '../configurations/AxiosConfig';

const getMarketplaceExtras = async (filtersProcessor) => {
	const request = `/Extras/RetrieveMarketPlace`;
	return axiosInstance.post(request, filtersProcessor);
};

const getExtrasTaken = async (filtersProcessor) => {
	const request = `/Extras/RetrieveExtrasTaken`;
	return axiosInstance.post(request, filtersProcessor);
};

const createLinkBetweenExtraCourier = async (extraName, courierId, region, start) => {
	const request = `/Extras/LinkExtraToCourier?extraName=${encodeURIComponent(
		extraName,
	)}&courierId=${courierId}&regionId=${region}&start=${start}`;
	return axiosInstance.post(request);
};

const createExtra = async (extraModel) => {
	const request = `/Extras`;
	return axiosInstance.post(request, extraModel);
};

const createExtraUsingShift = async (extraModel) => {
	const request = `/Extras/UsingShift`;
	return axiosInstance.post(request, extraModel);
};

const deleteExtra = async (extraName, start, region) => {
	const request = `/Extras?extraName=${encodeURIComponent(
		extraName,
	)}&start=${start}&regionId=${region}`;
	return axiosInstance.delete(request);
};

const getExtrasStatistics = async (date, region) => {
	const request = `/Extras/Statistiques?date=${date}&regionId=${region}`;
	return axiosInstance.get(request);
};

const getAnalyzer = async (date, region) => {
	const request = `/Extras/Analyzer?date=${date}&regionId=${region}`;
	return axiosInstance.get(request);
};

const exportExtrasLinkToCourier = async (searchExportFilter) => {
	const request = `/Extras/Export`;
	return axiosInstance.post(request, searchExportFilter, { responseType: 'blob' });
};

const createPreassignedExtra = async (extraModel) => {
	const request = `/Extras/Preassign`;
	return axiosInstance.post(request, extraModel);
};

const createPreassignedExtraUsingShift = async (extraModel) => {
	const request = `/Extras/PreassignUsingShift`;
	return axiosInstance.post(request, extraModel);
};

/**
 * Solde mensuel d'heures d'extra d'un coursier (LSE).
 *
 * Le mois attendu est celui du LUNDI de la semaine de l'extra, pas celui de l'extra : c'est sur ce mois
 * que porte le contrôle à l'attribution. La vue est recalculée à chaque lecture côté backend, donc la
 * réponse est toujours à jour.
 *
 * @param {number} courierId identifiant du coursier
 * @param {number} annee année du lundi de la semaine
 * @param {number} mois mois du lundi de la semaine (1-12)
 * @return {*}
 */
const getCourierExtraBalance = async (courierId, annee, mois) => {
	const request = `/Extras/Balance?courierId=${courierId}&annee=${annee}&mois=${mois}`;
	return axiosInstance.get(request);
};

const ExtraService = {
	getMarketplaceExtras,
	getExtrasTaken,
	createLinkBetweenExtraCourier,
	deleteExtra,
	createExtraUsingShift,
	createExtra,
	getExtrasStatistics,
	getAnalyzer,
	exportExtrasLinkToCourier,
	createPreassignedExtra,
	createPreassignedExtraUsingShift,
	getCourierExtraBalance,
};

export default ExtraService;
